<div class="task-card">
    <div class="due" [ngClass]="{ 'alert-hidden': !due }">{{due}}</div>
    <div class="count">{{count}}</div>
    <div class="title">{{title}}</div>
    <div class="description">{{description}}</div>
    <a [href]="taskLink" target="_blank">{{consts.TASK_LINK_LABEL}} &#8594;</a>
</div>
